import React, { memo } from "react";
import Icon from "./Icon";
const Mic = /*#__PURE__*/memo(props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
  d: "M11 0.916672C10.2707 0.916672 9.57118 1.2064 9.05546 1.72213C8.53973 2.23785 8.25 2.93733 8.25 3.66667V11C8.25 11.7293 8.53973 12.4288 9.05546 12.9445C9.57118 13.4603 10.2707 13.75 11 13.75C11.7293 13.75 12.4288 13.4603 12.9445 12.9445C13.4603 12.4288 13.75 11.7293 13.75 11V3.66667C13.75 2.93733 13.4603 2.23785 12.9445 1.72213C12.4288 1.2064 11.7293 0.916672 11 0.916672V0.916672Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.4166 9.16667V11C17.4166 12.7018 16.7405 14.3339 15.5372 15.5373C14.3338 16.7406 12.7017 17.4167 10.9999 17.4167C9.29811 17.4167 7.66601 16.7406 6.46265 15.5373C5.25929 14.3339 4.58325 12.7018 4.58325 11V9.16667"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 17.4167V21.0833"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.33325 21.0833H14.6666"
})));
Mic.displayname = "Mic";
export default Mic;
//# sourceMappingURL=Mic.js.map